import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { EmployeesService } from '../../services/employees/employees.service';
import { TrackingSegmentService } from '@unico-people/shared/data-access-tracking-segment';
import { SegmentEventName } from '@unico-people/shared/enums/utils-enums';

@Component({
  selector: 'sidebar-envelope-document',
  templateUrl: './sidebar-envelope-document.component.html',
  styleUrls: ['./sidebar-envelope-document.component.scss']
})
export class SidebarEnvelopeDocumentComponent {
  @Input() document: any;
  @Input()
  set openDocumentDetails(open: boolean) {
    this.showDocumentDetails = open;
  }
  @Input() employee: string;
  @Output() menu = new EventEmitter<boolean>();
  @Output() load = new EventEmitter<boolean>();

  showDocumentDetails = false;  
  showCpf = false;
  loadDownloadDoc = false;
  loadOpenDoc = false;

  constructor(
    public router: Router, 
    private employeesService: EmployeesService,
    private segment: TrackingSegmentService
    ) {}

  toggleSidebar(): void {
    this.showDocumentDetails = !this.showDocumentDetails;
    this.menu.emit(this.showDocumentDetails);
  }

  downloadDocumet() {
    this.loadDownloadDoc = true;
    this.trackinSegment(SegmentEventName.document_download);
    this.employeesService.downloadDocumentEmployee(this.employee, this.document.uuid)
    .subscribe(res => {
      let url = window.URL.createObjectURL(res);
      let a = document.createElement('a');
      a.href = url;
      a.download = this.document.documentType;
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
      this.loadDownloadDoc = false;
    });
  }

  openDocumet() {
    this.loadOpenDoc = true;
    this.trackinSegment(SegmentEventName.document_opened);
    this.employeesService.downloadDocumentEmployee(this.employee, this.document.uuid)
    .subscribe(res => {
      let url = window.URL.createObjectURL(res);
      let a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
      this.loadOpenDoc = false;
    });
  }

  openCpf() {
    this.showCpf = !this.showCpf;
    this.trackinSegment(SegmentEventName.document_show_cpf);
  }

  trackinSegment(eventTitle) {
    this.segment.track(eventTitle, { 
      status: this.document.envelopeStatus,
      category: this.document.documentCategoryName,
      location: 'Sidepanel'
    });
  }
}
